import { render, staticRenderFns } from "./suppliers_page.vue?vue&type=template&id=40886dbc&scoped=true"
import script from "./suppliers_page.vue?vue&type=script&lang=js"
export * from "./suppliers_page.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40886dbc",
  null
  
)

export default component.exports